const AttributeUploadResponse = {
  MissingAttributes: "missingAttributes",
  MissingUsers: "missingUsers",
  MissingCohorts: "missingCohorts",
  UsersUpdated: "usersUpdated",
};

export default AttributeUploadResponse;
